import classNames from 'classnames';
import React, {ButtonHTMLAttributes, memo, MouseEventHandler} from 'react';
import style from './style.module.scss';
import {TPropsWithClassName} from 'core/types';
import Icon from 'components/Icon';

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    disabled?: boolean;
}

export const UpButton = memo<TPropsWithClassName<IProps>>(
    ({className, disabled = false, type = 'button', onClick, ...restButtonAttributes}) => {
        const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
            onClick?.(e);
        };

        return (
            <button
                {...restButtonAttributes}
                className={classNames(className, style.upButton)}
                data-autotest-target={'catalog-nav'}
                data-autotest-target-id={'catalog-nav-up-btn'}
                disabled={disabled}
                onClick={handleClick}
                type={type}
            >
                <Icon className={style.arrow} icon={'arrow-right'} />
            </button>
        );
    },
);
